import React from 'react'
import { PreviewStyles } from './Style'

const Preview = () => {
    return (
        <PreviewStyles>
            <div className='wrap-preview'>
                <div className='title'>
                    מבדק לדוגמא
                </div>
                {/* <div className='description'>
                    המבדק נועד להתנסות בלבד ולא נכנס למערכת החינוך
                </div> */}
            </div>
        </PreviewStyles>
    )
}

export default Preview